import { Checkbox as CheckboxRad } from 'radix-ui'
import SelectedCheckmarkIcon from '../CustomIcons/SelectedCheckmarkIcon'
import { cn } from '../utlis/cn'
import { useMemo } from 'react'
import './checkbox.css'
import LockIcon from '@/CustomIcons/LockIcon'

type CheckboxProps = {
    label?: string
    defaultChecked?: boolean
    checked?: boolean
    disabled?: boolean
    locked?: boolean
    tooltip?: string
    onChange?: (checked: boolean) => void
    className?: string
    labelClassName?: string
    onClick?: () => void
}

export function Checkbox(props: CheckboxProps) {
    const id = useMemo(() => {
        return 'checkbox-' + Math.random().toString(36).substring(2, 15)
    }, [])

    return (
        <CheckboxRad.Root
            id={id}
            defaultChecked={props.defaultChecked}
            onCheckedChange={(checked) => !props.locked && props.onChange?.(!!checked.valueOf())}
            checked={props.checked}
            disabled={props.disabled}
            onClick={props.onClick}
            className={cn(
                'muse-cb flex items-center gap-2 rounded-[8px]',
                props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            )}
        >
            <Indicator locked={props.locked} className={cn(props.className)} />
            {props.label && (
                <label htmlFor={id} className={cn('text-left cursor-pointer', props.labelClassName)}>
                    {props.label}
                </label>
            )}
        </CheckboxRad.Root>
    )
}

type IndicatorProps = {
    locked?: boolean
    className?: string
}
function Indicator(props: IndicatorProps) {
    if (props.locked) {
        return <LockIcon style={{ fontSize: '1.3rem' }} />
    }

    return (
        <div className={cn('muse-cb-box w-[20px] min-w-[20px] h-[20px] rounded-[8px]', props.className)}>
            <CheckboxRad.Indicator className="w-[20px] h-[20px] flex items-center justify-center text-black">
                <SelectedCheckmarkIcon style={{ fontSize: '1.3rem' }} />
            </CheckboxRad.Indicator>
        </div>
    )
}
